import type { ReactNode } from 'react'
import '../views/screens.css'

interface ConfirmDialogProps {
  label: string
  children: ReactNode
  confirmText?: string
  confirmDisabled?: boolean
  onConfirm: () => void
  onCancel: () => void
}

// Same lightweight overlay the Feature Flags confirm uses (screen-confirm-*).
export function ConfirmDialog({
  label,
  children,
  confirmText = 'Confirm',
  confirmDisabled = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <div className="screen-confirm-backdrop" role="dialog" aria-modal="true" aria-label={label}>
      <div className="screen-confirm">
        {children}
        <div className="screen-confirm-actions">
          <button type="button" className="screen-btn" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="screen-btn screen-btn-primary"
            disabled={confirmDisabled}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}
